/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { CHAT_ENDPOINTS } from 'SharedDir/backend/endpoints/chats';
import { ChatImplementation, Chats } from 'SharedDir/declarations/chats';
import { StatusResponse } from 'SharedDir/declarations/endpoint';
import { Limited, OffsetParams } from 'SharedDir/declarations/pagination';

export class ChatsApiClass implements ChatImplementation {
  async addParticipant(chatId: Chats.Chat['id'], data: Pick<Chats.Participant, 'userId'>) {
    const { data: status } = (await http({
      ...CHAT_ENDPOINTS.ADD_PARTICIPANT(chatId.toString()),
      data,
    })) as AxiosResponse<StatusResponse>;
    return status;
  }

  async createChat(data: Chats.CreateChat) {
    const { data: chat } = (await http({
      ...CHAT_ENDPOINTS.CREATE_CHAT,
      data,
    })) as AxiosResponse<Chats.Chat>;
    return chat;
  }

  async deleteMessage(chatId: Chats.Chat['id'], messageId: Chats.Message['id']) {
    const { data } = (await http(
      CHAT_ENDPOINTS.DELETE_MESSAGE(chatId.toString(), messageId.toString())
    )) as AxiosResponse<Chats.Message>;
    return data;
  }

  async getChats<T extends Record<string, any> = {}>(params: Partial<OffsetParams> & T = {} as T) {
    const { data } = (await http({ ...CHAT_ENDPOINTS.GET_CHATS, params })) as AxiosResponse<
      Limited<Chats.Chat> & T
    >;
    return data;
  }

  async getChat(chatId: string) {
    const { data } = (await http(CHAT_ENDPOINTS.GET_CHAT(chatId))) as AxiosResponse<Chats.Chat>;
    return data;
  }

  public async getMessages(
    id: Chats.Chat['id'],
    params: Partial<OffsetParams> = {}
  ): Promise<Limited<Chats.Message>> {
    const { data } = await http({ ...CHAT_ENDPOINTS.GET_MESSAGES(id.toString()), params });
    return data;
  }

  async sendMessage(id: Chats.Chat['id'], data: Chats.CreateMessage) {
    const { data: message } = (await http({
      ...CHAT_ENDPOINTS.SEND_MESSAGE(id.toString()),
      data,
    })) as AxiosResponse<Chats.Message>;
    return message;
  }

  async toggleMute(chatId: Chats.Chat['id']): Promise<StatusResponse> {
    const { data: status } = (await http(
      CHAT_ENDPOINTS.TOGGLE_MUTE(chatId.toString())
    )) as AxiosResponse<StatusResponse>;
    return status;
  }

  async togglePin(chatId: Chats.Chat['id']): Promise<StatusResponse> {
    const { data: status } = (await http(
      CHAT_ENDPOINTS.TOGGLE_PIN(chatId.toString())
    )) as AxiosResponse<StatusResponse>;
    return status;
  }

  async updateMessage(
    chatId: Chats.Chat['id'],
    messageId: Chats.Message['id'],
    data: Chats.CreateMessage
  ): Promise<Chats.Message> {
    const { data: message } = (await http({
      ...CHAT_ENDPOINTS.UPDATE_MESSAGE(chatId.toString(), messageId.toString()),
      data,
    })) as AxiosResponse<Chats.Message>;
    return message;
  }
}
